import { InjectionToken } from '../../injection';

/**
 * @deprecated Will be removed as soon as subpackages stop using it.
 */
export interface IMobizTranslateService {
  translate(key: string, interpolateParams?: object, namespace?: string): string;
}

/**
 * @deprecated Will be removed as soon as subpackages stop using it.
 */
export const MOBIZ_TRANSLATE_SERVICE: InjectionToken<IMobizTranslateService>
  = new InjectionToken<IMobizTranslateService>('MOBIZ_TRANSLATE_SERVICE');
